/**
 * Split array into chunks
 * @param array array to split
 * @param chunkSize size of each chunk
 * @returns
 **/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get chunkArray () {
        return chunkArray;
    },
    get validateAndStringifyJson () {
        return validateAndStringifyJson;
    }
});
function chunkArray(array, chunkSize) {
    const chunks = [];
    for(let i = 0; i < array.length; i += chunkSize){
        chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
}
function validateAndStringifyJson(val) {
    let jsonVal;
    let isValidJson = false;
    if (typeof val === 'object' && val !== null) {
        jsonVal = JSON.stringify(val);
        isValidJson = true;
    } else if (typeof val === 'string') {
        try {
            JSON.parse(val);
            jsonVal = val;
            isValidJson = true;
        } catch (e) {
            jsonVal = val;
            isValidJson = false;
        }
    } else {
        // Handle other types (number, boolean, undefined, etc.)
        jsonVal = String(val);
        isValidJson = false;
    }
    return {
        jsonVal,
        isValidJson
    };
}
